<template>
    <div class="new-article">
      <Breadcrumbs :breadcrumbs="breadcrumbs"/>
      <Divider type="horizontal" />
      <div class="title mb-4">
          {{ article.title }}
      </div>
      <div class="row revers-mobile">
        <div class="col-12 col-md-6">
          <img :src="article.previewImageUrl" alt="" width="100%" height="100%">
        </div>
        <div class="col-12 col-md-6 mt-auto mb-auto">
          <div class="content" v-html="article.content"></div>
<!--          <div  class="author" v-if="article.author">-->
<!--            {{ article.author }}-->
<!--          </div>-->
          <div v-if="article.publishedAt" class="publish-date">
            {{ article.publishedAt }}
          </div>
        </div>
      </div>
    </div>
</template>

<script>

// import preview from './components/preview';
import { show as articleShow } from '@/api/article';
import Breadcrumbs from "@/shared/ui/breadcrumbs/breadcrumbs/index.vue";
import {Divider} from "@/shared/ui/divider";
// import previewLoader from './components/previewLoader';

export default {
    components: {
      Divider, Breadcrumbs
      // previewLoader,
        // preview
    },
  computed: {
    breadcrumbs() {
      return [
        {
          title: 'Головна',
          path: '/'
        },
        {
          title: 'Ресурси',
        },
        {
          title: 'Новини',
          path: '/news'
        },
        {
          title: this.article.title,
        }
      ]
    }
  },
    data: function () {
        return {
            condition: {
                isLoadArticle: true,
            },
            article: {},
        }
    },
    created: async function() {
        let response =  await articleShow(this.$route.params.slug).catch(() => {
            this.$router.push('/prime')
        });

        if (response?.data?.data) {
            this.article = response.data.data
        } else {
            this.$router.push('/prime')
        }
    },
}
</script>

<style lang="scss" scoped>
.new-article {
  .title {
    font-family: 'Roboto',serif;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 44px;
    /* identical to box height, or 183% */

    color: #09090B;
    text-align: center;
  }
  .content {
    /* M3/headline/small */
    font-family: 'Roboto',serif;
    font-style: normal;
    font-weight: 400;
    font-size: 24px;
    line-height: 32px;
    /* or 133% */
    color: #09090B;
    ::v-deep a {
      color: #007bff !important;
    }
  }
  .publish-date {
    font-family: 'Roboto',serif;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 32px;
    color: #71717A;
  }
  .revers-mobile {
    @media (max-width: 768px) {
      flex-direction: column-reverse;
    }
  }
}

</style>
